'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_POPUP_V1 = {
  maskClosable: true,
  maskStyle: {
    backgroundColor: "rgba(0, 0, 0, 0.1)"
  },
  commonStyle: {
    width: 400,
    backgroundColor: "#fff",
    padding: {
      left: 16,
      right: 16,
      bottom: 16,
      top: 16
    }
  },
  position: "default",
  zIndex: 1050,
  closeIcon: {
    size: 18
  },
  displayOncePerSession: false
};
const WAITING_FOR_DISABLED_POPUP = 5e3;

exports.DEFAULT_POPUP_V1 = DEFAULT_POPUP_V1;
exports.WAITING_FOR_DISABLED_POPUP = WAITING_FOR_DISABLED_POPUP;
